import { useCallback } from 'react';
/**
 * Scrolls the spot list to the previewed spot
 * @param previewedSpotId
 * @param isMobile
 */
export const useScrollToPreviewedSpot = ({ previewedSpotId, isMobile, }) => {
    return useCallback(() => {
        const previewedSpotElement = window.document.querySelector(`[data-spot="${previewedSpotId}"]`);
        if (!previewedSpotElement)
            return;
        // Handle mobile scrolling
        if (isMobile) {
            previewedSpotElement.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center',
            });
            return;
        }
        // Handle desktop scrolling
        const scrollContainer = previewedSpotElement.closest('#SpotListWrapper');
        if (!(scrollContainer instanceof HTMLElement))
            return;
        const elemNode = previewedSpotElement;
        const containerRect = scrollContainer.getBoundingClientRect();
        const elemRect = elemNode.getBoundingClientRect();
        const offsetFromContainerTop = elemRect.top - containerRect.top;
        const targetTop = scrollContainer.scrollTop +
            offsetFromContainerTop -
            scrollContainer.clientHeight / 2 +
            elemRect.height / 2;
        scrollContainer.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth',
        });
    }, [isMobile, previewedSpotId]);
};
